import React, { useEffect, useRef } from 'react'
import { useSelectedAudioOutput, useMissionPauseForRef } from './hooks'
import type { MediaRef } from '../utility'

type Props = {
	volume?: number,
	applyMissionPause?: boolean,
	vocalTrackId?: string,
}

/**
 * The html 5 audio element that will appropriately switch output device to the selected audio output
 */
const ConnectedAudioNoRef = (
	{ volume, applyMissionPause, vocalTrackId, ...props }: Props,
	passedRef: MediaRef
) => {
	const newRef = useRef()
	const ref = passedRef || newRef
	useSelectedAudioOutput(ref)
	useMissionPauseForRef(ref, { applyMissionPause })

	useEffect(() => {
		if (ref.current && typeof volume === 'number') {
			ref.current.volume = volume
		}
	}, [volume, ref])

	// $FlowFixMe refs are hard with flow
	return <audio {...props} ref={ref} />
}

// $FlowFixMe refs are hard with flow
export const ConnectedAudio = React.forwardRef(ConnectedAudioNoRef)
